export const PROCESSOR_LABELS = Object.freeze({
    GetUserMedia: 'GetUserMedia',
    VideoProcessor: 'VideoProcessor',
    AudioProcessor: 'AudioProcessor',
    AudioMixingProcessor: 'AudioMixingProcessor',
});

export const GET_USER_MEDIA_TIMEOUT_MS = 10_000;
export const DEVICE_CHANGE_DEBOUNCE_TIMEOUT_MS = 500;
export const MAX_TENT_BLUR_SIZE = 9;
